import type { ApiCallError } from "Infrastructure/Api/ApiUtils";
import type { Path, UseFormReturn } from "react-hook-form";

export const formSetErrors = <T extends object>(
	form: UseFormReturn<T>,
	error: ApiCallError,
) => {
	Object.keys(error.data.data?.errors ?? {}).forEach((key) => {
		const message = error.data?.data?.errors?.[key];

		if (message) {
			form.setError(key as Path<T>, {
				message,
			});
		}
	});
};
